{
  "name": "kunai-app",
  "description": "Power tools for Power Automate (Microsoft Flow)",
  "version": "1.4.12",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "dev": "concurrently -k --handle-input --default-input-target api -n ng,api,swa -c cyan,magenta,green \"npm:dev:ng\" \"npm:dev:api\" \"npm:dev:swa\"",
    "dev:ng": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng serve --configuration dev",
    "dev:api": "cd api && npm run dev",
    "dev:swa": "swa start --config swa-cli.config.json --port 4280 --devserver-timeout 180000",
    "start": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng serve --configuration dev",
    "start:ng": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng serve --configuration dev",
    "build": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration prod --aot",
    "build-prod": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration prod --aot",
    "build-dev": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration dev --aot",
    "start-web": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng serve --configuration web",
    "build-web": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration web --aot",
    "swa": "node scripts/start-swa.js",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:debug": "playwright test --debug",
    "e2e:headed": "playwright test --headed",
    "e2e:dev": "playwright test --config playwright.dev.config.ts playwright/tests/04-dev-smoke.spec.ts",
    "e2e:dev:headed": "playwright test --config playwright.dev.config.ts --headed playwright/tests/04-dev-smoke.spec.ts",
    "e2e:dev:routes": "playwright test --config playwright.dev.config.ts playwright/tests/06-route-coverage.spec.ts",
    "e2e:prod": "playwright test --config playwright.prod.config.ts playwright/tests/04-dev-smoke.spec.ts playwright/tests/06-route-coverage.spec.ts",
    "e2e:prod:headed": "playwright test --config playwright.prod.config.ts --headed playwright/tests/04-dev-smoke.spec.ts playwright/tests/06-route-coverage.spec.ts",
    "e2e:prod:routes": "playwright test --config playwright.prod.config.ts playwright/tests/06-route-coverage.spec.ts",
    "e2e:local:routes": "playwright test --project=chromium playwright/tests/06-route-coverage.spec.ts",
    "ver": "npm --no-git-tag-version version patch"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.16",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/forms": "^21.2.16",
    "@angular/localize": "^21.2.16",
    "@angular/platform-browser": "^21.2.16",
    "@angular/platform-browser-dynamic": "^21.2.16",
    "@angular/router": "^21.2.16",
    "@angular/service-worker": "^21.2.16",
    "@apollo/client": "^3.10.4",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.28.1",
    "@fluentui/svg-icons": "^1.1.323",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-common-types": "^6.5.2",
    "@fortawesome/fontawesome-svg-core": "^6.5.2",
    "@fortawesome/free-regular-svg-icons": "^6.5.2",
    "@fortawesome/free-solid-svg-icons": "^6.5.2",
    "@microsoft/applicationinsights-web": "^2.8.18",
    "@progress/kendo-angular-buttons": "^24.1.0",
    "@progress/kendo-angular-charts": "^24.1.0",
    "@progress/kendo-angular-common": "^24.1.0",
    "@progress/kendo-angular-conversational-ui": "^24.1.0",
    "@progress/kendo-angular-dateinputs": "^24.1.0",
    "@progress/kendo-angular-dialog": "^24.1.0",
    "@progress/kendo-angular-dropdowns": "^24.1.0",
    "@progress/kendo-angular-excel-export": "^24.1.0",
    "@progress/kendo-angular-grid": "^24.1.0",
    "@progress/kendo-angular-icons": "^24.1.0",
    "@progress/kendo-angular-indicators": "^24.1.0",
    "@progress/kendo-angular-inputs": "^24.1.0",
    "@progress/kendo-angular-intl": "^24.1.0",
    "@progress/kendo-angular-l10n": "^24.1.0",
    "@progress/kendo-angular-label": "^24.1.0",
    "@progress/kendo-angular-layout": "^24.1.0",
    "@progress/kendo-angular-listview": "^24.1.0",
    "@progress/kendo-angular-menu": "^24.1.0",
    "@progress/kendo-angular-navigation": "^24.1.0",
    "@progress/kendo-angular-notification": "^24.1.0",
    "@progress/kendo-angular-pager": "^24.1.0",
    "@progress/kendo-angular-pdf-export": "^24.1.0",
    "@progress/kendo-angular-popup": "^24.1.0",
    "@progress/kendo-angular-progressbar": "^24.1.0",
    "@progress/kendo-angular-ripple": "^24.1.0",
    "@progress/kendo-angular-scheduler": "^24.1.0",
    "@progress/kendo-angular-scrollview": "^24.1.0",
    "@progress/kendo-angular-sortable": "^24.1.0",
    "@progress/kendo-angular-toolbar": "^24.1.0",
    "@progress/kendo-angular-tooltip": "^24.1.0",
    "@progress/kendo-angular-treeview": "^24.1.0",
    "@progress/kendo-angular-utils": "^24.1.0",
    "@progress/kendo-angular-upload": "^24.1.0",
    "@progress/kendo-data-query": "^1.7.4",
    "@progress/kendo-date-math": "^1.5.17",
    "@progress/kendo-drawing": "^1.25.2",
    "@progress/kendo-font-icons": "^5.1.0",
    "@progress/kendo-licensing": "^1.11.2",
    "@progress/kendo-svg-icons": "^5.1.0",
    "@progress/kendo-theme-default": "^14.1.0",
    "@progress/kendo-theme-fluent": "^14.1.0",
    "@uifabric/icons": "^7.9.5",
    "angulartics2": "^13.0.0",
    "apollo-cache": "^1.3.5",
    "apollo-cache-persist": "^0.1.1",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "core-js": "^2.4.1",
    "graphql": "^15.10.1",
    "hammerjs": "^2.0.0",
    "html2canvas-pro": "^2.0.2",
    "js-base64": "^2.5.1",
    "jsoneditor": "^5.15.0",
    "jszip": "^3.10.1",
    "localforage": "^1.10.0",
    "localforage-getitems": "^1.4.2",
    "localforage-setitems": "^1.4.0",
    "monaco-editor": "^0.55.1",
    "ngx-monaco-editor-v2": "^18.0.0",
    "office-ui-fabric-core": "^11.1.0",
    "rx-query": "^2.0.1",
    "rxjs": "^7.8.1",
    "sql.js": "^1.14.1",
    "svg-pan-zoom": "^3.6.1",
    "tslib": "2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.14",
    "@angular/build": "^21.2.14",
    "@angular/cli": "^21.2.14",
    "@angular/compiler-cli": "^21.2.16",
    "@angular/language-service": "21.2.16",
    "@azure/static-web-apps-cli": "^2.0.8",
    "@fluentui/web-components": "^2.6.1",
    "@playwright/test": "^1.58.2",
    "@tailwindcss/postcss": "^4.1.18",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^20.12.12",
    "caniuse-lite": "^1.0.30001551",
    "codelyzer": "^6.0.0",
    "concurrently": "^10.0.3",
    "cross-env": "^7.0.3",
    "jasmine-core": "^5.1.2",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "protractor": "~7.0.0",
    "sass": "^1.35.1",
    "tailwindcss": "^3.4.19",
    "ts-node": "~4.1.0",
    "tslint": "~6.1.0",
    "typescript": "5.9.3"
  }
}
